import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import { Comment } from 'components/secondaryMarket/cpOrder/sidePanel/ready/comment';
import { ActionButton, ButtonPanel, MessagesPanel } from 'components/secondaryMarket/shared/status';
import { KycScore } from 'components/secondaryMarket/shared/status/KycScore';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import type { IntlKey } from 'locales';
import type { Form } from 'state/secondaryMarket/shared/form/form.model';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { KycDetail, KycScoreStatus } from 'state/secondaryMarket/shared/kyc/kyc.model';
import type { SecondaryMarketPostEventTabType } from 'state/workspaces/model';

export type ApplySidePanelProps<F = Form> = Readonly<{
  tabType: SecondaryMarketPostEventTabType;
  kycScore?: KycScoreStatus | undefined;
  kycDetails?: readonly KycDetail[] | undefined;
  canApply: boolean;
  comment: string | undefined;
  validationErrors: readonly SecondaryMarketFormError<F>[];
  backendReports: readonly SecondaryMarketFormError<F>[];
  onApply: () => void;
  onCommentChanged: (value: string) => void;
  readyLabelKey: IntlKey;
  notReadyLabelKey: IntlKey;
  applyLabelKey: IntlKey;
}>;
export function ApplyAmendSidePanel<F = Form>({
  onApply,
  canApply,
  kycScore,
  kycDetails,
  comment,
  onCommentChanged,
  validationErrors,
  readyLabelKey,
  notReadyLabelKey,
  applyLabelKey,
  backendReports,
}: ApplySidePanelProps<F>) {
  return (
    <div className="d-flex flex-column h-100 overflow-y-auto">
      <PanelHeader color="primary" discreet />
      <PanelFooter
        textColor={canApply ? undefined : 'secondary'}
        color="primary"
        discreet
        statusKey={canApply ? readyLabelKey : notReadyLabelKey}
        icon="offline_bolt"
      />
      {kycScore !== undefined && <KycScore className="mx-2 my-3" status={kycScore} details={kycDetails} />}

      <MessagesPanel
        errors={[...validationErrors, ...backendReports]}
        className="flex-grow-1 pt-2"
        e2e="side-panel-header"
        colorToSeverity={lessAgressiveColorMapper}
      />
      <ButtonPanel>
        <Comment onCommentChanged={onCommentChanged} comment={comment} />
        <ActionButton color="info" label={applyLabelKey} disabled={!canApply} onClick={onApply} />
      </ButtonPanel>
    </div>
  );
}
ApplyAmendSidePanel.displayName = 'ApplyAmendSidePanel';
